import React, { useState } from "react";
import { notificaitonModalData } from "../common/Helper";

import { Link } from "react-router-dom";

const NotificaitonModal = () => {
  const [showAllNotificaitonCard] = useState(); //Show All Notificaiton Card

  // Determine the visible items based on the showAll card
  const visibleItems = showAllNotificaitonCard
    ? notificaitonModalData
    : notificaitonModalData.slice(0, 4);
  return (
    <>
      <div className="bg-white rounded-3xl shadow-my_contacts_tabs_shadow pt-7 pb-5 pl-4 pr-5 max-w-[500px]">
        {visibleItems.map((value, index) => (
          <div
            className=" rounded-xl bg-light_purple7 pt-5 pb-3 px-6 my-[10px]"
            key={index}>
            <div className="flex items-center">
              <span className="w-[49px] h-[49px]">
                {value.notificationIcon}
              </span>
              <p className="text-sm md:text-[18px] font-normal leading-[137%] pl-7">
                {value.notificationText}
              </p>
            </div>
          </div>
        ))}
        <div className="flex justify-center">
          {!showAllNotificaitonCard && notificaitonModalData.length > 4 && (
            <Link
              to="/notificaiton-page"
              className="text-xs  3xl:text-[16px] font-normal inline-block text-primary text-center rounded-3xl bg-[rgba(111,_106,_248,_0.08)] px-8 py-2 hover:bg-primary hover:text-white duration-200">
              View all
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificaitonModal;
